/**
 * @format
 */
import {connect} from 'react-redux';
import {TempsPageView} from '../components';

const TempsPage = connect()(TempsPageView);

export {TempsPage};
